import { LuEllipsisVertical, LuPlus } from 'react-icons/lu';

import { DropdownMenuTrigger } from './dropdown-menu';

export const EllipsisDropdownMenuTrigger = ({ ariaLabel = 'Actions' }: { ariaLabel?: string }) => (
    <DropdownMenuTrigger asChild>
        <button
            className="flex h-8 w-8 items-center justify-center rounded-md transition-colors hover:bg-gray-100 focus-visible:ring-0 focus-visible:outline-none"
            aria-label={ariaLabel}
        >
            <LuEllipsisVertical className="h-4 w-4 text-gray-500" />
        </button>
    </DropdownMenuTrigger>
);

// The small "+" that sits on a card's label row; same hover treatment as the ellipsis trigger.
export const PlusDropdownMenuTrigger = ({ ariaLabel = 'Add' }: { ariaLabel?: string }) => (
    <DropdownMenuTrigger asChild>
        <button
            className="flex h-5 w-5 items-center justify-center rounded transition-colors hover:bg-gray-100 focus-visible:ring-0 focus-visible:outline-none"
            aria-label={ariaLabel}
        >
            <LuPlus className="h-3.5 w-3.5 text-gray-500" />
        </button>
    </DropdownMenuTrigger>
);
